import styled from 'styled-components';
import React, { useState , useEffect, useContext} from 'react';
import { useSpring, animated } from 'react-spring';
import axios from 'axios';
import { ArticlesContext  } from './sportsc/articlesContext';
// Main container that wraps the entire article, designed for a full-screen display.
// It uses styles to replicate the Tailwind classes from the original HTML.
const ArticleContainer = styled(animated.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width:400px;
  min-height: 80vh;
  background-color: #f8fafc; /* bg-slate-50 */
  justify-content: space-between;
  overflow-x: hidden;
  font-family: 'Newsreader', 'Noto Sans', sans-serif;
`;

// A flex container for the top header section, including the back arrow and title.
const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #f8fafc; /* bg-slate-50 */
  padding: 1rem; /* p-4 */
  padding-bottom: 0.5rem; /* pb-2 */
  justify-content: space-between;
`;

// Styled component for the back arrow icon.
const BackArrowIcon = styled.div`
  color: #0e141b;
  display: flex;
  width: 3rem; /* size-12 */
  height: 3rem; /* size-12 */
  flex-shrink: 0;
  align-items: center;
`;

// Styled component for the main article heading.
const ArticleTitle = styled.h2`
  color: #0e141b;
  font-size: 1.125rem; /* text-lg */
  font-weight: 700; /* font-bold */
  line-height: 1.5; /* leading-tight */
  letter-spacing: -0.015em; /* tracking-[-0.015em] */
  flex: 1;
  text-align: center;
  padding-right: 3rem; /* pr-12 */
`;

// Another styled component for the main headline of the article.
const MainHeadline = styled.h2`
  color: #0e141b;
  letter-spacing: -0.025em; /* tracking-light */
  font-size: 1.75rem; /* text-[28px] */
  font-weight: 700; /* font-bold */
  line-height: 1.5; /* leading-tight */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
  padding-bottom: 0.75rem; /* pb-3 */
  padding-top: 1.25rem; /* pt-5 */
  text-align: left;
`;

// A styled paragraph for the author and date.
const AuthorText = styled.p`
  color: #4e7397;
  font-size: 0.875rem; /* text-sm */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
  padding-bottom: 0.75rem; /* pb-3 */
  padding-top: 0.25rem; /* pt-1 */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
`;

// A styled paragraph for the main body of the article.
const BodyText = styled.p`
  color: #0e141b;
  font-size: 1rem; /* text-base */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
  padding-bottom: 0.75rem; /* pb-3 */
  padding-top: 0.25rem; /* pt-1 */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
`;

// The main React component that assembles all the styled components.
 function Article({article}) {
  
  return (
    <ArticleContainer>
      <div>
        <HeaderWrapper>
          {/* <BackArrowIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
              <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
            </svg>
          </BackArrowIcon> */}
          <ArticleTitle>Article</ArticleTitle>
        </HeaderWrapper>
        <MainHeadline>
            {article.title}
        </MainHeadline>
        <AuthorText>{article.published_date}</AuthorText>
<BodyText>
  {`${article.body_text}`.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))}


</BodyText>
      </div>
    </ArticleContainer>
  );
}
const FullScreenOverlay = styled(animated.div)`
  position: fixed;
top: 0;
left: 0;
  width: 100%;
  height: 100vh;
  background-color: white; // Or any background color you prefer
  z-index: 100; // Ensure it's on top of other content
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
`;

const FullArticle = ({ onClose }) => {
    const { articles, id } = useContext(ArticlesContext);
    const [article, setOneArticle] = useState(null);

    useEffect(() => {
        // Find the article whenever `articles` or `id` changes
        const foundArticle = articles.find((art) => art.article_id === id);
        if (foundArticle) {
            setOneArticle(foundArticle);
        }
    }, [articles, id]); // Correct dependency array

    const mountTransition = useSpring({
        from: { opacity: 0, transform: 'scale(0.8)' },
        to: { opacity: 1, transform: 'scale(1)' },
        config: { duration: 300 }
    });

    const unmountTransition = useSpring({
        from: { opacity: 1, transform: 'scale(1)' },
        to: { opacity: 0, transform: 'scale(0.8)' },
        config: { duration: 3000 },
        immediate: false
    });

    const props = onClose ? mountTransition : unmountTransition;

    return (
        <FullScreenOverlay style={props}>
            {/* Correct way to render a component with props */}
            {article && <Article article={article} />}
            <button onClick={onClose}>Close</button>
        </FullScreenOverlay>
    );
};
const GameAnalysisContainer = styled.div`
  display: flex;
  flex-direction: column; /* Stack items vertically */
  width: 100%; /* Take up the full viewport width */
  height: 100vh; /* Take up the full viewport height */
  overflow-y: auto; /* Enable vertical scrolling when content overflows */
  background-color: #f8fafc; /* Optional: Set a background color */
`;
const GameAnalysisContent = styled.div`
  display: flex;
  height:15%;
  flex-direction: column;
  justify-content: center;
`;

const GameAnalysisTitle = styled.p`
  color: #0e141b;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
`;

const GameAnalysisDescription = styled.p`
  color: #4e7397;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
`;

const GameAnalysisAuthor = styled.p`
  color: #4e7397;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
`;




function Articles() {
      const [showFullArticle, setShowFullArticle] = useState(false);
    const { setArticles, articles, setId} = useContext(ArticlesContext);


        async function fetchArticles() {
    console.log('trying to get credits')
    try {
      axios({
        method: 'post',
        url: `https://dhqs56xckk.execute-api.us-east-2.amazonaws.com/pred_dev/load`,
       
        withCredentials: false,
        data: {
          path:'articles'
        },
      }).then(function (response) {
         const data = response.data;
         console.log('as', data)
         let newData = data.toReversed()
          setArticles(newData)

      })
      .catch(function (error) {
      });
    } catch (error) {
        console.error('Error:', error);
    }
}


useEffect(() => {
        fetchArticles();
    }, [])
  const handleTitleClick = () => {
    setShowFullArticle(true);
  };

  const handleClose = () => {
    setShowFullArticle(false);
  };
  return (
    <GameAnalysisContainer>
              {showFullArticle && <FullArticle onClose={handleClose} />}

{articles.map((article) => (
  <GameAnalysisContent key={article.article_id}>
    <GameAnalysisTitle
      onClick={() => {
        handleTitleClick();
        setId(article.article_id);
        setTimeout(() => {
  // Your code to be executed after the timeout
  console.log("This message will appear after 1.5 seconds.");
}, 100);
      }}
    >
      {article.title}
    </GameAnalysisTitle>
    <GameAnalysisDescription>{article.description}</GameAnalysisDescription>
    <GameAnalysisAuthor>{article.published_date}</GameAnalysisAuthor>
  </GameAnalysisContent>
))}
    </GameAnalysisContainer>
  );
}

export default Articles;